if (!customElements.get("carousel-scrollbar")) {
  customElements.define(
    "carousel-scrollbar",
    class extends HTMLElement {
      connectedCallback() {
        this.thumb = this.firstElementChild;
        this.onUpdate = this.onUpdate.bind(this);
        if (!this.carousel) return;

        this.carousel.addEventListener("scroll", this.onUpdate, { passive: true });
        this.carousel.addEventListener("carousel:change", this.onUpdate);
        this.carousel.addEventListener("carousel:filter", this.onUpdate);
        this.resizeObserver = new ResizeObserver(this.onUpdate);
        this.resizeObserver.observe(this.carousel);
        this.onUpdate();
      }

      disconnectedCallback() {
        this.carousel?.removeEventListener("scroll", this.onUpdate);
        this.carousel?.removeEventListener("carousel:change", this.onUpdate);
        this.carousel?.removeEventListener("carousel:filter", this.onUpdate);
        this.resizeObserver?.disconnect();
      }

      get carousel() {
        return document.getElementById(this.getAttribute("aria-controls"));
      }

      onUpdate() {
        const carousel = this.carousel;
        if (!carousel || !this.thumb) return;

        const maxScroll = Math.max(carousel.scrollWidth - carousel.clientWidth, 0);
        if (maxScroll <= 0) return;

        const trackWidth = this.clientWidth;
        const thumbWidth = trackWidth * (carousel.clientWidth / carousel.scrollWidth);
        const maxTravel = Math.max(trackWidth - thumbWidth, 0);
        const progress = Math.min(Math.max(Math.abs(carousel.scrollLeft) / maxScroll, 0), 1);

        this.thumb.style.width = `${thumbWidth}px`;
        this.thumb.style.transform = `translate3d(${progress * maxTravel}px, 0, 0)`;
      }
    }
  );
}
